import FormLabel from '@mui/material/FormLabel'
import invariant from 'invariant'
import { connectField, createAutoField, HTMLFieldProps } from 'uniforms'
import { DateField, ListField, RadioField, SelectField, TextField } from 'uniforms-mui'
import BooleanRadioField from './BooleanRadioField'
import NumberField from './NumberField'
import wrapField from './wrapField'

// FIXME: wrapField is not typed correctly.
export type NestFieldProps = HTMLFieldProps<
  object,
  HTMLDivElement,
  { helperText?: string; itemProps?: object; fullWidth?: boolean; margin?: any }
>

function Nest({
  children,
  fields,
  fullWidth = true,
  itemProps,
  label,
  margin = 'dense',
  ...props
}: NestFieldProps) {
  return wrapField(
    {
      fullWidth,
      margin,
      ...props,
      component: undefined,
    },
    label && <FormLabel component="legend">{label}</FormLabel>,
    children || fields.map(field => <AutoField key={field} name={field} {...itemProps} />)
  )
}

const NestField = connectField<NestFieldProps>(Nest)

const AutoField = createAutoField(props => {
  if (props.component) {
    return props.component
  }

  if (props.options) {
    return props.checkboxes && props.fieldType !== Array ? RadioField : SelectField
  }

  switch (props.fieldType) {
    case Array:
      return ListField
    case Boolean:
      return BooleanRadioField
    case Date:
      return DateField
    case Number:
      return NumberField
    case Object:
      return NestField
    case String:
      return TextField
  }

  return invariant(false, 'Unsupported field type: %s', props.fieldType)
})

export default AutoField
